export enum TrackedChannel {
  NC = "NC",
  PUSH = "PUSH",
  EMAIL = "EMAIL",
}

export enum Category {
  MARKET = "CATEGORY_MARKET",
  FLIGHT = "CATEGORY_FLIGHT",
  HOLIDAY_RENTAL = "CATEGORY_HOLIDAY_RENTAL",
}

export enum Channel {
  WEB = "web",
  EMAIL = "email",
  PUSH = "push",
}

export const SupportedChannels: Record<Category, Channel[]> = {
  [Category.MARKET]: [Channel.WEB, Channel.EMAIL, Channel.PUSH],
  [Category.FLIGHT]: [Channel.WEB, Channel.EMAIL],
  [Category.HOLIDAY_RENTAL]: [Channel.WEB, Channel.EMAIL],
};

export interface NotificationChannels {
  [Channel.WEB]?: boolean;
  [Channel.EMAIL]?: boolean;
  [Channel.PUSH]?: boolean;
}

export interface BaseSavedSearch {
  id: number;
  name: string;
  notifications: NotificationChannels;
}

export enum ChannelDto {
  NC = "NC",
  PUSH = "PUSH",
  EMAIL = "EMAIL",
}

export interface SavedSearchInput {
  description?: string;
  type: string;
  searchKey: string;
  parameters: Record<string, string[]>;
}

export interface MarketSavedSearchDto extends SavedSearchInput {
  id: number;
  description: string;
  notifications: ChannelDto[];
}

export interface FlightSavedSearchDto {
  id: number;
  name: string;
  web: boolean;
  mail: boolean;
}

export interface HolidayRentalSavedSearchDto {
  id: number;
  name: string;
  web: boolean;
  mail: boolean;
  params?: string;
}
